export class EmailRegex {

    constructor() {

        if (EmailRegex.instance) { // Prevents creation of multiple instances
            return EmailRegex.instance;
        }
        
        // Initialise properties
        this.regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/

        // Save instance
        EmailRegex.instance = this;
    }

    test(email: string) {
        return this.regex.test(email);
    }

}